import React from "react";

const BS5_ButtonGroups = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_ButtonGroups Component</h2>
      <p>This is the BS5_ButtonGroups component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_ButtonGroups;
